import { NotSelected } from "../../../Constant/Setting";
import { Agent } from "../../../Shared-ui/Types/Agent";

export const agentInitial: Agent = {
    name: "",
    description: "",
    api_key: "",
    role: "Document Agent",
    model: NotSelected,
    is_active: true,
    instructions: "",
    reasoning_steps: false,
    is_shared: false,
    show_reasoning: true,
    knowledge_base_ids: [],
    tool_ids: [],
    show_tool_calls: true,
    agent_metadata: {
        rag_settings: {
            add_references: true,
            search_knowledge: true,
        },
        streaming: true,
        enable_zeasecure: false,
        zeasecure_api_key: "",
        markdown: true,
        page_context_awareness: false,
        user_context_awareness: false,
        voice_enabled: false,
    },
};

export const agentErrInitial = {
    name: { error: "", value: false },
    description: { error: "", value: false },
    api_key: { error: "", value: false },
    instructions: { error: "", value: false },
    role: {
        error: "",
        value: false,
    },
    model: {
        error:
            "Select the provider and model that best suits your agent's needs. Different models excel at different tasks.",
        value: false,
    },
    provider: { error: "", value: false },
    zeasecure_api_key: { error: "", value: false },
};